@if (props && props['items']) {
  @if (props['items'].length > 0) {
    <div class="items">
      @for (item of props['items']; track item; let i = $index; let isFirst = $first) {
        <button class="mentions-item" [class.is-selected]="i === selectedIndex" (click)="selectItem(i)">
          <img class="mentions-avatar" [src]="item['avatar']" alt="" height="28" width="28" />
          <span class="mention-displayname">{{ item['displayname'] }}</span>
        </button>
      }
    </div>
  }
}
